<template>
  <section>
    <main class="main-wrapper flex-grow-1 with-footer comment bg-documentGray">
      <div class="d-flex align-items-center bg-white">
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center  flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
          <div class="font-m">{{ $t("30000") }}</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="container">
        <div class="d-flex">
          <filter-bar
		          :key="filterKey"
		          :aggregationData="aggregationData"
		          @callNewFilterList="callNewFilterList"
		          @resetFilter="resetFilter" >
          </filter-bar>
          <div class="mgt-33 flex-grow-1">
            <div class="d-flex justify-content-between">
              <div class="t-body2 t-color-bodyGrayA font-r">{{ $t("30001", { str: cardData && cardData.totalElements }) }}</div>
              <dropdown :sortOptions="sortOptions" class="mgt--12 micro-drop-down" @searchSort="searchSort"></dropdown>
            </div>
            <div class="divider mgt-11 mgb-12"></div>
            <NoData v-if="isNoData" :msgData="{msg1:'30208', msg2:'30209'}"></NoData>
            <div v-else>
              <div v-for="(card, index) in cardDataList" :key="index">
              <list-item :cardData="card"></list-item>
              </div>
              <paginate
                v-model="page"
                :click-handler="goToSearch"
                :container-class="'pagination'"
                :next-text="'<span class=material-icons >keyboard_arrow_right'"
                :page-class="'pagination-item'"
                :page-count="totalPageComp"
                :page-range="pageRangeComp"
                :prev-text="'<span class=material-icons >keyboard_arrow_left'">
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import microCourseApi from "@/api/microCourseApi";
import {FILTER_LIST} from './utils/constants';
import CategoryList from "@/components/common/CategoryList.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import filterBar from '@/components/microDegree/view/FilterBar';
import NoData from '@/components/common/NoData';

const SortOptions = [
  {
    translateKey: "30002",
    sortValue: "id,desc",
    sortType : {
            "value" : "RECENTLY_ADDED"
          },
    isShow: true,
  },
  {
    translateKey: "30003",
    sortValue: "learnerCount,desc",
    sortType: {
            "value" : "LEARNER_COUNT_DESC"
          },
    isShow: false,
  },
  {
    translateKey: "30004",
    sortValue: "reviewCount",
    sortType: {
            "value" : "REVIEW_COUNT"
    },
    isShow: false,
  },
  {
    translateKey: "30005",
    sortValue: "reviewAvg",
    sortType: {
            "value" : "REVIEW_AVG"
    },
    isShow: false,
  },
];

export default {
  name: "List",

  components: {
    NoData,
    filterBar,
    CategoryList,
    'top-app-bar': () => import('@/components/TopAppBar'),
    'top-app-drawer': () => import('@/components/TopAppBarDrawer'),
    'list-item': () => import('@/components/microDegree/view/ListItem'),
    'dropdown': () => import('@/components/common/RightListSortOptions')
  },

	mixins: [topAppBarMixin],

  data() {
    return {
	    filterKey: 1,
      cardData: null,
      cardDataList: [],
      aggregationData: [],
      isNoData: false,
      page: 1,
      totalPage: 1,
      currentPage: Number(this.$route.query.page),
      staticPageCount: 10,
	    microDegreeFetch: {
		    review: null,
		    categories: null,
		    subjects: null,
		    levels: null,
		    runningTime: null,
		    resourceTypes: null,
		    free: null,
		    lecture: null,
		    courseLanguageCode: null,
		    subtitleLanguageCode: null
	    },
      languageIndex: [
        'English',
        '한국어',
        '中文',
        '繁體中文',
        'Español',
        'Português',
        'Deutsch',
        'ភាសាខ្មែរ',
        'kiswahili',
        'हिन्दी',
        'العربية'
      ],
      sortOptions: SortOptions
    }
  },

  computed: {
    isFirstPages() {
      return this.totalPage <= this.staticPageCount || this.currentPage >= Number(this.staticPageCount);
    },

    totalPageComp() {
      return this.isFirstPages ? this.totalPage : this.staticPageCount;
    },

    pageRangeComp() {
      return this.isFirstPages ? 9 : 11;
    }
  },

  mounted() {
	  this.page = parseInt(this.$route.query.page ? this.$route.query.page : 1);
		if (this.$route.query.sort) {
			this.setSearchOption(this.$route.query.sort);
		}
	  this.queryParamToMicroDegreeFetch();
	  this.searchList();
  },

  methods: {
		queryParamToMicroDegreeFetch() {
			Object.keys(this.microDegreeFetch).forEach(item=> {
				let routeQuery = this.$route.query[item];
				if (routeQuery === undefined || routeQuery === null) {
					return;
				}
				if (!Array.isArray(routeQuery)) {
					routeQuery = routeQuery.toString();
				}
				let queryValue = [];
				if (routeQuery !== '' && routeQuery.length > 0) {
					queryValue = item === FILTER_LIST.review.paramKey ? routeQuery : routeQuery.split(",");
				}
				this.microDegreeFetch[item] = queryValue;
			});
		},

    search() {
      this.initData();
    },

    searchSort(value) {
      this.setSearchOption(value);
      this.search();
    },

    setSearchOption(value) {
      this.sortOptions = SortOptions;

      this.sortOptions.map((sort) => {
        sort.isShow = sort.sortValue === value;
      });
    },

    currentSortValue() {
      const sort = this.currentSort();
      return sort.sortValue.toString();
    },

    currentSort() {
      return this.sortOptions.find((sort) => sort.isShow === true);
    },

    resetFilter() {
	    this.$router.push({
		    name: "MicroCourseList"
	    });
    },

    initData() {
      this.page = 1;
	    Object.keys(this.microDegreeFetch).forEach(fetch=>{
				this.microDegreeFetch[fetch] = null;
	    });
	    this.callNewFilterList();
    },
	  
	  goToSearch() {
			let queries = {};
		  Object.keys(this.microDegreeFetch).forEach(fetch => queries[fetch] = Array.isArray(this.microDegreeFetch[fetch]) ? this.microDegreeFetch[fetch].join(",") : this.microDegreeFetch[fetch]);
			this.$router.push({
				name: "MicroCourseList",
				query: Object.assign(this.setParam(), queries)
			});
	  },
	
	  searchList() {
		  this.$showLoading();
		  let responseData = null;
		  let params = this.setParams();
		  
		  microCourseApi.callFilterList(params).then((response) => {
        responseData = response.data.data;
        this.aggregationData = responseData.aggregation;
        this.aggregationData = responseData.aggregation.map((data) => {
          if (data.type === FILTER_LIST.contents.name) {
            return {
              ...data,
              options: data.options.filter((option) => option.title !== 'LCMS')
            };
          }
          return data;
        });
        this.aggregationData = _.each(this.aggregationData, (aggre) => {
          if (aggre.type === FILTER_LIST.course_language.name || aggre.type === FILTER_LIST.subtitle_language.name) {
            return aggre.options.sort((a, b) => {
              const indexA = this.languageIndex.indexOf(a.title);
              const indexB = this.languageIndex.indexOf(b.title);
              if (indexA === -1 && indexB === -1) {
                return 0;
              } else if (indexA === -1) {
                return 1;
              } else if (indexB === -1) {
                return -1;
              } else {
                return indexA - indexB;
              }
            });
          }
        })

			  this.aggregationData.forEach(aggregation => {
				  const type = aggregation.type.toLowerCase();
				  const key = FILTER_LIST[type].paramKey;

				  aggregation.value = key === FILTER_LIST.review.paramKey ? '' : [];
					if (this.microDegreeFetch[key] !== null &&
							this.microDegreeFetch[key] !== undefined &&
							this.microDegreeFetch[key] !== '' &&
							this.microDegreeFetch[key].length) {
						aggregation.value = this.microDegreeFetch[key];
					}
			  });
				
			  this.cardData = responseData.item;
			  this.totalPage = this.cardData.totalPages;
			  this.cardDataList = responseData.item.content;

        if(this.cardData.content.length <= 0) {
          this.isNoData = true;
        }
			  this.$hideLoading();
		  });
			
	  },

    callNewFilterList () {
			this.page = 1;
	    this.aggregationData.forEach(aggregation => {
		    const type = aggregation.type.toLowerCase();
				const key = FILTER_LIST[type].paramKey;
		    this.microDegreeFetch[key] = aggregation.value;
	    });
	    this.goToSearch();
    },
	  
    setParams(value, name, isPermit) {
	    let params = {};
	    Object.keys(this.microDegreeFetch).map(fetch => {
	      params[fetch] = Array.isArray(this.microDegreeFetch[fetch]) ? this.microDegreeFetch[fetch].join(",") : this.microDegreeFetch[fetch];
	    });
			//파라미터와 페이지 및 정렬 조건을 합친다.
	    return Object.assign(this.organizeParams(params), this.setParam());
    },

	  organizeParams(params) {
		  Object.keys(params).forEach(value => {
			  params[value] = params[value] === '' ? null : params[value];
		  });

		  return params;
	  },

    setParam() {
      let params = {
        size: 10,
        page: this.page,
        sort: this.currentSortValue()
      }
      return params;
    },
  }
}
</script>

<style scoped>

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 24px
}
</style>
